import { render, staticRenderFns } from "./ViewerPage.vue?vue&type=template&id=3db4dbbf&scoped=true"
import script from "./ViewerPage.vue?vue&type=script&lang=js"
export * from "./ViewerPage.vue?vue&type=script&lang=js"
import style0 from "./ViewerPage.vue?vue&type=style&index=0&id=3db4dbbf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f9e102e5cbb5fa5aa7d45569a28cebe6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db4dbbf",
  null
  
)

export default component.exports